export default __webpack_public_path__ + "static/media/home11.9fb2198e.png";